import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const TOKEN_KEY = "aria_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const http = axios.create({ baseURL: API });

http.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

http.interceptors.response.use(
  (r) => r,
  (err) => {
    const path = window.location.pathname;
    if (err.response?.status === 401 && !path.startsWith("/login") && !path.startsWith("/auth")) {
      clearToken();
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export const api = {
  authConfig: () => http.get("/auth/config").then((r) => r.data),
  authGoogle: (code, redirect_uri) => http.post("/auth/google", { code, redirect_uri }).then((r) => r.data),
  me: () => http.get("/me").then((r) => r.data),
  connectGoogle: () => http.post("/connect/google").then((r) => r.data),
  disconnect: () => http.post("/disconnect").then((r) => r.data),
  sync: () => http.post("/sync").then((r) => r.data),
  updateSettings: (body) => http.put("/settings", body).then((r) => r.data),

  dashboard: () => http.get("/dashboard").then((r) => r.data),

  inbox: () => http.get("/inbox").then((r) => r.data),
  email: (id) => http.get(`/inbox/${id}`).then((r) => r.data),
  triage: () => http.post("/inbox/triage").then((r) => r.data),
  summarize: (id) => http.post(`/inbox/${id}/summarize`).then((r) => r.data),
  draft: (id, instruction) => http.post(`/inbox/${id}/draft`, { instruction }).then((r) => r.data),
  editDraft: (id, body) => http.put(`/drafts/${id}`, body).then((r) => r.data),
  proposeTimes: (id) => http.post(`/inbox/${id}/propose-times`).then((r) => r.data),

  calendar: () => http.get("/calendar").then((r) => r.data),

  tasks: () => http.get("/tasks").then((r) => r.data),
  createTask: (body) => http.post("/tasks", body).then((r) => r.data),
  updateTask: (id, body) => http.put(`/tasks/${id}`, body).then((r) => r.data),
  deleteTask: (id) => http.delete(`/tasks/${id}`).then((r) => r.data),
  suggestBlocks: (title, description) => http.post("/tasks/suggest-blocks", { title, description }).then((r) => r.data),
  autoSchedule: (id, weekStart) => http.post(`/tasks/${id}/auto-schedule${weekStart ? `?week_start=${weekStart}` : ""}`).then((r) => r.data),

  blocks: () => http.get("/blocks").then((r) => r.data),
  createBlock: (body) => http.post("/blocks", body).then((r) => r.data),
  moveBlock: (id, body) => http.put(`/blocks/${id}`, body).then((r) => r.data),
  toggleBlock: (id) => http.patch(`/blocks/${id}/toggle`).then((r) => r.data),
  deleteBlock: (id) => http.delete(`/blocks/${id}`).then((r) => r.data),

  workModes: () => http.get("/work-modes").then((r) => r.data),
  createWorkMode: (body) => http.post("/work-modes", body).then((r) => r.data),
  deleteWorkMode: (id) => http.delete(`/work-modes/${id}`).then((r) => r.data),

  actions: () => http.get("/actions").then((r) => r.data),
  approve: (id, idx = 0) => http.post(`/actions/${id}/approve?selected_index=${idx}`).then((r) => r.data),
  dismiss: (id) => http.post(`/actions/${id}/dismiss`).then((r) => r.data),
  actionLog: () => http.get("/actions/log").then((r) => r.data),

  briefing: () => http.get("/briefing").then((r) => r.data),
  generateBriefing: () => http.post("/briefing/generate").then((r) => r.data),
  notify: (subject, html_content) => http.post("/notify", { subject, html_content }).then((r) => r.data),
};
